import Swiper from 'swiper/bundle'
import imagesLoaded from 'imagesloaded'
import Vue from 'vue'
import UgoCare from '../vue/components/UgoCare.vue'
import Products from '../vue/components/HomeProduct.vue'

export default {
  init() {
    const hero = document.querySelector('.hero')
    const heroContainer = document.querySelector('.hero-swiper-container')
    const loader = document.querySelector('.loader')
    // const navigation = document.querySelector('.site-navigation li:fist-child')

    const heroSwiper = new Swiper(heroContainer, {
      // lazy: {
      //   loadPrevNext: true,
      // },
      autoplay: {
        delay: 4000,
      },
      init: false,
      loop: true,
      speed: 800,
      autoHeight: true,
      grabCursor: true,
      spaceBetween: 0,
      preventClicksPropagation: false,
      pagination: {
        el: heroContainer.querySelector('.pagination'),
        clickable: true,
        renderBullet(index, className) {
          return `<span class="${className}">${
            index + 1
          }<div class="rippleJS"></div></span>`
        },
      },
      navigation: {
        nextEl: heroContainer.querySelector('.next'),
        prevEl: heroContainer.querySelector('.prev'),
      },
    })

    imagesLoaded(hero, () => {
      hero.classList.remove('is-loading')
      document.body.classList.remove('is-loading')
      heroSwiper.init()
    })

    heroSwiper.on('slideChangeTransitionEnd init', (swiper) => {
      swiper.slides.forEach((element) => {
        element.classList.remove('is-active')
      })

      swiper.slides[swiper.realIndex].classList.add('is-active')
    })

    new Vue({
      el: '.ugo-care-product',
      components: { UgoCare },
    })

    new Vue({
      el: '.products',
      components: { Products },
    })

    const vh = window.innerHeight * 0.01
    hero.style.setProperty('--vh', `${vh}px`)
    window.addEventListener('resize', () => {
      const vh = window.innerHeight * 0.01
      hero.style.setProperty('--vh', `${vh}px`)
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
}
